import {useBreakpointValue} from '@chakra-ui/media-query';

export function useHeaderHeight() {
  return useBreakpointValue(['4rem', null, null, '6rem'])!;
}
